import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { FDPrimaryActionButton, FDStack } from '@facet-wealth/design';
import MetaLayoutVertical from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutVertical';
import { DataValueMap } from 'Helpers/Testing';
import React, { useState } from 'react';
import { useSnackbarContext } from 'Context/SnackbarContext';
import fr from 'facet-rest';
import FileUploadButtonRebranded from 'Components/ComponentLibrary/Components/Uncategorized/FileUploadButtonRebranded';
import {
  AttachmentsSectionRebranded,
} from 'Components/ComponentLibrary/Components/Uncategorized/AttachmentsSectionRebranded';
import { hasRelationship } from 'Helpers/Affordances';
import PropTypes from 'prop-types';

export default function MemberDataCaptureCurrentAccountEditLayout({ isReadOnly }) {
  const { resource, onSubmit } = useMetaLayoutContext();
  const { displayErrorMessage } = useSnackbarContext();
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = React.useState(null);
  const [attachments, setAttachments] = React.useState(resource?.attr('accountStatements'));
  const [currentResource, setCurrentResource] = React.useState(resource);

  const handleOnClick = async () => {
    try {
      setLoading(true);
      await onSubmit();
    } catch (err) {
      displayErrorMessage('Failed to submit current member data capture item');
    }
    setLoading(false);
  };

  const hasUploadRelationship = hasRelationship(currentResource, fr.relationships.uploadFile.name);
  const hasAttachments = attachments?.resources()?.length() > 0;

  const handleDeleteAttachment = async (attachment) => {
    await attachment.delete();
    const [accountResource] = await currentResource.link('self').get();
    setAttachments(accountResource.attr('accountStatements'));
    setCurrentResource(accountResource);
  };

  const onFileUploadSuccess = async () => {
    const [accountResource] = await currentResource.link('self').get();
    setAttachments(accountResource.attr('accountStatements'));
    setCurrentResource(accountResource);
  };

  return (
    <FDStack direction={'column'} alignItems={'stretch'} spacing={2}>
      {
        hasUploadRelationship
          ? (<FileUploadButtonRebranded
            attachmentCollection={currentResource?.attr('accountStatements')}
            onStart={() => currentResource?.relationship(fr.relationships.uploadFile.name)?.link('related').url()}
            onSuccess={() => onFileUploadSuccess()}
            onFailure={(e) => displayErrorMessage(e, 'Failed to upload file')}
            uploadProgress={uploadProgress}
            setUploadProgress={setUploadProgress}
            disabled={loading}
            buttonLabel={'Upload Statement'}
            test={'mdc-file-upload-button'}
          />) : null
      }
      {
        hasAttachments && hasUploadRelationship
          ? (<AttachmentsSectionRebranded
            attachmentsCollection={attachments}
            AttachmentProps={{
              onDelete: handleDeleteAttachment,
            }}
            eventCategory={'Member Data Capture'}
          />) : null
      }
      <MetaLayoutVertical resource={currentResource} />
      <FDPrimaryActionButton
        {...DataValueMap.init('member-data-capture-current-submit').build()}
        label="Submit"
        size={'lg'}
        isFullWidth
        disabled={isReadOnly || uploadProgress !== null}
        loading={loading}
        onClick={handleOnClick}
      />
    </FDStack>
  );
}

MemberDataCaptureCurrentAccountEditLayout.propTypes = {
  isReadOnly: PropTypes.bool.isRequired,
};
